// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZZEHi1v32o8HCu {
  display: block;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  height: 96px;
  padding: 8px;
  overflow: hidden;
  border-radius: 8px;
  cursor: progress;
  animation-name: zF_OH_mQDhR9w9;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
@keyframes zF_OH_mQDhR9w9 {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .ZZEHi1v32o8HCu {
    animation: none;
  }
}
.DH1pN0ycQlB7JA {
  display: block;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  height: 128px;
  padding: 8px;
  overflow: hidden;
  border-radius: 8px;
  cursor: progress;
  animation-name: zF_OH_mQDhR9w9;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
@keyframes zF_OH_mQDhR9w9 {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .DH1pN0ycQlB7JA {
    animation: none;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skeleton": `ZZEHi1v32o8HCu`,
	"shimmer": `zF_OH_mQDhR9w9`,
	"newTileSkeleton": `DH1pN0ycQlB7JA`
};
export default ___CSS_LOADER_EXPORT___;
